/**
 * генерация id
 */
/**
 * Генерируем рандомные строковые ID
 * Ex: '3f1a34e0fea33d5d6c9cdb10'
 * @param a
 */
export const generateHash = (a?: number): string => {
  return a
    ? (a ^ ((Math.random() * 16) >> (a / 4))).toString(16)
    : `${1e10}${1e10}${1e1}`
        .replace(
          /[01]/g,
          // @ts-ignore
          generateHash
        )
        .toLowerCase();
};

export const generateNumericHash = (hash: string, seed = 0) => {
  let h1 = 0xdeadbeef ^ seed,
    h2 = 0x41c6ce57 ^ seed;

  for (let i = 0, ch; i < hash.length; i++) {
    ch = hash.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }

  h1 =
    Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^
    Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 =
    Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^
    Math.imul(h1 ^ (h1 >>> 13), 3266489909);

  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};
